export default __webpack_public_path__ + "static/media/FractureEquationImg.4f2307e7.PNG";